import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import request from 'app/requests/LongTermLease/LongTermLease.requests'
import {
    LongTermLeaseType,
} from '../longTermLease.types'

const useGetLongTermLease = (id: number) => {
    return useRequest<LongTermLeaseType>({
        key: RequestKeys.getLongTermLease,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(request.get),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}

export default useGetLongTermLease
